/** Opções para o multiselect de configuração dos grupos de classificações */
export interface GrupoClassificacaoConfigMultiselectOptions {
    id: number;
    nome: string;
}

export const optionConsiderarClienteAnaliseMercado: GrupoClassificacaoConfigMultiselectOptions = {
    id: 1,
    nome: 'Considerar na Análise de Mercado'
};

export const optionConsiderarMeta: GrupoClassificacaoConfigMultiselectOptions = {
    id: 2,
    nome: 'Considerar na Meta'
};
